import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Tells the TV receiver (or any parent) which app route is visible now.
// The receiver forwards it to the phone as `state.route`, so the phone mirror
// can load the same page.

const RouteBroadcast = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          source: 'flexwatch-app',
          type: 'route',
          path: location.pathname + location.search,
        }, '*');
      }
    } catch (e) {
      /* parent is unavailable or cross-origin */
    }
  }, [location.pathname, location.search]);

  return null;
};

export default RouteBroadcast;
